import './Footer.css';
import { FaFacebookF, FaTwitter, FaInstagram } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';
import { Link } from 'react-router-dom';
import logo from '../assets/logo1.png';

export default function Footer({ user }) {
  const adminEmail = 'duxbyteinformatica@gmail.com';
  const isAdmin = user?.email === adminEmail;

  return (
    <footer id="footer" className="footer">
      <div className="footer-container">

        {/* Logo */}
        <div className="footer-column footer-logo">
          <img src={logo} alt="Logo de Duxbyte" className="logo1" />
        </div>

        {/* Enlaces rápidos */}
        <div className="footer-column1">
          <h3>Enlaces</h3>
          <ul>
            <li><a href="/">Inicio</a></li>
            <li><a href="/servicios">Servicios</a></li>
            <li><a href="/sobre-nosotros">Sobre Nosotros</a></li>
            <li><a href="/contacto">Contacto</a></li>
          </ul>
        </div>

        {/* Contacto */}
        <div className="footer-column2">
          <h3>Contacto</h3>
          <ul>
            <li><MdEmail /> duxbyteinformatica@gmail.com</li>
            <li><MdPhone /> +34 666 29 07 95</li>
            <li><MdLocationOn /> Jerez de la Frontera, España</li>
          </ul>
        </div>

        {/* Redes sociales */}
        <div className="footer-column3">
          <h3>Síguenos</h3>
          <ul className="socials">
            <li>
              <a href="https://facebook.com/duxbyte" className="social-link" target="_blank" rel="noopener noreferrer">
                <FaFacebookF /> Facebook
              </a>
            </li>
            <li>
              <a href="https://instagram.com/duxbyte" className="social-link" target="_blank" rel="noopener noreferrer">
                <FaInstagram /> Instagram
              </a>
            </li>
            <li>
              <a href="https://twitter.com/duxbyte" className="social-link" target="_blank" rel="noopener noreferrer">
                <FaTwitter /> Twitter
              </a>
            </li>
            <li>
              <a href="https://tiktok.com/@duxbyte" className="social-link" target="_blank" rel="noopener noreferrer">
                <SiTiktok /> TikTok
              </a>
            </li>
          </ul>
        </div>

      </div>
      <div className="footer-bottom">
        {isAdmin && (
              <li>
                <Link to="/admin" className="admin-link admin-link-highlight">Zona de Administrador</Link>
              </li>
              )}
        &copy; {new Date().getFullYear()} Duxbyte Informática.
      </div>
    </footer>
  );
}
